"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var core_1 = require("@material-ui/core");
var checkLinkIsOuterLink_1 = __importDefault(require("./fn/checkLinkIsOuterLink"));
var fn_1 = require("./fn/fn");
var CustomLink = function (_a) {
    var _b = _a.href, href = _b === void 0 ? '' : _b, isTargetBlank = _a.isTargetBlank, children = _a.children;
    var isOuterLink = checkLinkIsOuterLink_1.default(href);
    //console.log(isOuterLink);
    if (!href) {
        return (react_1.default.createElement(react_1.default.Fragment, null, children));
    }
    if (isOuterLink) {
        return (react_1.default.createElement(core_1.Link, { href: href, target: fn_1.getIsTargetBlankStr(isTargetBlank), underline: 'none' }, children));
    }
    return (react_1.default.createElement(react_router_dom_1.Link, { to: href }, children));
};
exports.default = CustomLink;
